<script>
  import { getAppConfig } from '../../../../common/config/app-config';
  import { globalCurrencyTag } from '../../../../common/util';
  import Text from '../../../common/components/Text.svelte';

  export let currency;
  export let tasheelPriceValuesList;
  export let discountPrice;
  export let price;
  export let percentageDiscount;

  const { lang } = getAppConfig();

  const productSellingPrice = discountPrice === null ? price?.formattedValue : discountPrice?.formattedValue;
  const hasDiscount = discountPrice !== null;

  // $: currentTasheelPriceValue =
  //   (tasheelPriceValuesList && tasheelPriceValuesList.length > 0 && tasheelPriceValuesList[0]) || null;
  // $: tasheelPrice = currentTasheelPriceValue && currentTasheelPriceValue.priceValueTasheel.formattedValue;
  // const tasheelInstallMonths = ACC.config.unbxdSearchConfig.tasheelInfo.tasheelInstallmentMonths;
  // $: tasheelPercentage = currentTasheelPriceValue && currentTasheelPriceValue.tasheelPercentage;

  // const mon = getStr('extra.pdp.monthLable');
</script>

<div class="tile-price-container d-flex flex-column">
  <div class="price-with-discount-wrapper price-wrapper">
    <div class="price-and-extra d-flex justify-content-between">
      <div class="price-side">
        {#if lang == 'en'}{@html globalCurrencyTag}{/if}
        <span class="price">{productSellingPrice}</span>
        {#if lang == 'ar'}{@html globalCurrencyTag}{/if}
      </div>
      {#if percentageDiscount?.formattedValue}
        <div class="discount-side d-flex">
          {percentageDiscount?.formattedValue}% <Text key="off" />
        </div>
      {/if}
    </div>
    {#if hasDiscount && discountPrice?.formattedValue}
      <div class="secondary-price offer-price">
        {price?.formattedValue}
      </div>
    {/if}
  </div>
  <!-- {#if tasheelPriceValuesList && tasheelPriceValuesList.length > 0 && tasheelPrice && tasheelInstallMonths && tasheelPercentage}
    <div class="tasheel-with-emi-wrapper price-wrapper">
      <div class="price-and-extra d-flex justify-content-between">
        <div class="price-side tasheel-price">
          {@html globalCurrencyTag}
          <span class="price">{tasheelPrice && tasheelPrice}/{mon}</span>
        </div>
        <div class="tasheel-icon hide-on-desktop">
          <Icon
            type="url"
            glyph={`${tasheelInfo.tasheelIconUrl ? tasheelInfo.tasheelIconUrl : APP_CONSTANTS.CDN_EXTRASTORE + '/2x/secondary/tasheel-logos.svg'}`}
            alt="Tasheel logo"
            mobileSize="16"
            desktopSize="20"
          />
        </div>
        <div class="tasheel-icon hide-on-mobile">
          <Icon
            type="url"
            glyph={`${tasheelInfo.tasheelImageUrl ? tasheelInfo.tasheelImageUrl : APP_CONSTANTS.CDN_EXTRASTORE + '/2x/secondary/tasheel-logos.svg'}`}
            alt="Tasheel logo"
            mobileSize="26"
            desktopSize="20"
          />
        </div>
      </div>
      <div class="emi-offer secondary-price">
        <Text key="extra.tasheel.priceValue.desc" args={[tasheelPercentage, tasheelInstallMonths]} />
      </div>
    </div>
  {/if} -->
</div>

<style lang="scss">
  @import '../../../common/styles/colors.new.scss';

  .price-with-discount-wrapper {
    padding-bottom: 4px;
    @include desktop-min-width {
      padding-bottom: 6px;
    }
  }
  .tasheel-with-emi-wrapper {
    padding-top: 4px;
    border-top: 1px solid $secondary-gray-02;
    @include desktop-min-width {
      padding-top: 6px;
    }
    .emi-offer {
      &.secondary-price {
        text-decoration-line: none;
      }
    }
  }

  .price-wrapper {
    .price-and-extra {
      color: $neutral-dark-01;
      font-size: 1.4em;
      line-height: 16px;
      @include desktop-min-width {
        font-size: 16px;
        line-height: 18px;
      }
      .price-side .price {
        font-weight: 700;
      }
      .discount-side {
        padding: 3px 4px;
        color: $extraTagTextColor;
        background: $extraTagBg;
        gap: 2px;
        font-weight: 700;
        font-size: 10px;
        line-height: 12px;
        border-radius: 3px;
        height: 16px;
        text-transform: uppercase;
      }
    }
    .secondary-price {
      color: $neutral-dark-03;
      font-size: 12px;
      line-height: 14px;
      text-decoration-line: line-through;
    }
  }
</style>
